// Action Buttons Widget Configuration
// A single-select action widget. The picker offers four actions —
// Buy / Sell / Maintain / Close — while the legacy long/short value keys
// remain valid stored values so existing TaskProgress data keeps parsing.

export type TradingScoreValue =
  | 'buy_to_add'
  | 'sell_to_reduce'
  | 'maintain'
  | 'buy_to_cover'
  | 'sell_to_short'
  | 'exit';

export interface TradingScoreOption {
  value: TradingScoreValue;
  label: string;
}

// Display label for every stored value, collapsed to the four-action
// vocabulary (Buy / Sell / Maintain / Close) — so legacy long/short entries
// (buy_to_cover, sell_to_short) still render as Buy / Sell.
export const TRADING_SCORE_LABELS: Record<TradingScoreValue, string> = {
  buy_to_add: 'Buy',
  buy_to_cover: 'Buy',
  sell_to_reduce: 'Sell',
  sell_to_short: 'Sell',
  maintain: 'Maintain',
  exit: 'Close',
};

// The four actions offered in the picker.
export const TRADING_SCORE_OPTIONS: TradingScoreOption[] = [
  { value: 'buy_to_add', label: 'Buy' },
  { value: 'sell_to_reduce', label: 'Sell' },
  { value: 'maintain', label: 'Maintain' },
  { value: 'exit', label: 'Close' },
];

export const TRADING_SCORE_STYLES: Record<
  TradingScoreValue,
  { active: string; badge: string }
> = {
  buy_to_add: {
    active: 'border-success-500 bg-success-100 text-success-800 ring-1 ring-success-200 shadow-sm',
    badge: 'bg-success-500 text-white',
  },
  sell_to_reduce: {
    active: 'border-danger-500 bg-danger-100 text-danger-800 ring-1 ring-danger-200 shadow-sm',
    badge: 'bg-danger-500 text-white',
  },
  maintain: {
    active: 'border-neutral-400 bg-neutral-100 text-neutral-700 ring-1 ring-neutral-200 shadow-sm',
    badge: 'bg-neutral-500 text-white',
  },
  buy_to_cover: {
    active: 'border-success-500 bg-success-100 text-success-800 ring-1 ring-success-200 shadow-sm',
    badge: 'bg-success-500 text-white',
  },
  sell_to_short: {
    active: 'border-danger-500 bg-danger-100 text-danger-800 ring-1 ring-danger-200 shadow-sm',
    badge: 'bg-danger-500 text-white',
  },
  exit: {
    active: 'border-neutral-400 bg-neutral-100 text-neutral-700 ring-1 ring-neutral-200 shadow-sm',
    badge: 'bg-neutral-500 text-white',
  },
};

export interface TradingScoreWidgetConfig {}

export interface TradingScoreWidgetInstanceConfig extends TradingScoreWidgetConfig {
  dataKey: string;
}

export interface TradingScoreDataContent {
  action?: TradingScoreValue;
}
